<template>
  <section>
    <h2 class="h2Title">삼성 회원 관리</h2>
    <article class="fieldMb">
      <form class="fieldWrap">
        <div class="fieldBx">
          <ul>
            <li class="formList">
              <dl>
                <dd>
                  <v-radio-group v-model="param.searchSecMember" row v-on:change="search">
                    <v-radio
                        v-for="(s, idx) in userTypes"
                        :key="idx"
                        :label="s.text"
                        :value="s.value"
                    ></v-radio>
                  </v-radio-group>
                </dd>
              </dl>
              <dl>
                <dd>
                  <date-range-component v-on:event="getSearchDate" label="등록일" :value="searchDate"></date-range-component>
                </dd>
              </dl>
              <dl>
                <!--                <dt class="formTit">역할</dt>-->
                <dd>
                  <div class="monthBx">
                    <button type="button" class="btn month" v-for="(month, idx) in monthLists"
                            :class="{ active: month === activeItem}"
                            @click="selectItem(month.value, idx)" :key="idx">{{ month.text }}
                    </button>
                  </div>
                </dd>
              </dl>
            </li>
            <li class="formList">
              <dl>
                <dd>
                  <v-col sm="12" class="d-flex">
                    <v-select :items="[{text:'Y', value:true}, {text:'N', value:false}]" item-value="value" item-text="text" v-model="param.searchIsAntiGraftLawTarget"
                              dense
                              clearable
                              flat
                              outlined
                              hide-details
                              label="청탁금지법대상 여부"
                              style="padding-right: 10px; max-width: 180px;"
                              @change="search"
                    />
                  <v-select :items="searchColumns" item-value="value" item-text="text" v-model="param.searchColumn"
                            dense
                            clearable
                            flat
                            outlined
                            hide-details
                            label="검색 컬럼"
                            style="padding-right: 10px; max-width: 200px;"
                            @change="search"
                            />
                  <v-text-field :label="searchColumnText"
                                v-model="searchValue"
                                v-on:keyup.enter="search"
                                dense clearable flat outlined
                                style="max-width: 320px;"
                  />
                  </v-col>
                </dd>
              </dl>

            </li>
          </ul>
<!--          <div class="searchBtn">-->
<!--            <v-btn color="#424964" @click="search()" depressed dark>검색</v-btn>-->
<!--          </div>-->
        </div>
      </form>
    </article>
    <article class="tableWrap">
      <div class="tableBtnBx">
        <p class="searchAll">
          &nbsp;
<!--          <v-checkbox class="mgr" label="" v-model="all" :true-value="true" :false-value="false"/>-->
<!--          검색 된 총 <span class="txtPoint">{{ totalItems }}명</span> 선택-->
        </p>
        <div class="tableBtn">
          <ul>
<!--            <li class="tableBtnList"><span class="black-color">{{ selected.length }}</span> 건 선택됨</li>-->
<!--            <li class="tableBtnList">-->
<!--              <v-btn color="#58d8a3" depressed dark @click="smsDialogVisible=true">SMS 발송</v-btn>-->
<!--            </li>-->
<!--            <li class="tableBtnList">-->
<!--              <v-btn color="#ffc105" depressed dark @click="mailDialogVisible=true">Mail 발송</v-btn>-->
<!--            </li>-->

            <li class="tableBtnList" style="padding-right: 2px">
              <v-btn color="#1991eb" dark @click="excelUploadDialog">
                <v-icon left dark>cloud_upload</v-icon>
                엑셀 업로드
              </v-btn>
            </li>
            <li class="tableBtnList">
              <v-btn color="#607d8b" depressed dark @click="excelDownload">
                <v-icon left dark>cloud_download</v-icon>
                엑셀 다운로드
              </v-btn>
            </li>
            <li class="tableBtnList">
              <v-btn class="vBtn vIconResize mgr" @click="createForm" color="primary" dark>
                <v-icon left>mdi mdi-playlist-plus</v-icon>
                등록
              </v-btn>
            </li>
          </ul>
        </div>
      </div>
      <div class="tableBx">
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="users"
            :server-items-length="totalItems"
            :options.sync="options"
            item-key="userId"
            class="elevation-1"
            :footer-props="{showFirstLastPage: true, 'items-per-page-options' : [10,20,50,100,-1]}"
            disable-sort
            @click:row="onRowClick"
        >

          <template v-slot:item.isSecManaged="{value}">
            {{ value ? '삼성전자 관리 회원' : '전자사랑 회원' }}
          </template>
          <template v-slot:item.isAntiGraftLawTarget="{value}">
            <span :class="value ? 'red--text' : ''">{{ value ? '대상자' : '비대상' }}</span>
          </template>

<!--          <template v-slot:item.userId="{value}">-->
<!--            <a @click.stop="onRowClick(value)">-->
<!--            {{ value }}-->
<!--            </a>-->
<!--          </template>-->
          <template v-slot:item.birthDate="{value, item}">
            {{ value }} {{ value != null ? item.lunarBirth ? '(음력)' : '(양력)' : '' }}
          </template>

          <template v-slot:item.createdAt="{ value }">
            {{ value | moment('YYYY-MM-DD HH:mm:ss') }}
          </template>

          <template v-slot:item.actions="{ item }">
<!--            <v-icon-->
<!--                small-->
<!--                class="mr-2"-->
<!--                @click.stop="updateForm(item)"-->
<!--                :disabled="!item.isSecManaged"-->
<!--            >-->
<!--              mdi-pencil-->
<!--            </v-icon>-->
            <v-btn color="orange"
                   @click.stop="deleteUser(item)"
                   :disabled="!item.isSecManaged"
                   v-if="item.isSecManaged"
                   dark small>
              <v-icon
                  small
                  class="mr-2"
              >
                mdi-delete
              </v-icon>
              삭제
            </v-btn>
          </template>


        </v-data-table>

        <v-dialog v-model="smsDialogVisible" max-width="350px" @click:outside="smsDialogVisible = false" @keydown.esc="smsDialogVisible = false">
          <v-card class="mx-auto">
            <v-system-bar>
              SMS 발송
              <v-spacer></v-spacer>
              <v-icon @click="smsDialogVisible = false">mdi-close</v-icon>
            </v-system-bar>
            <v-card-text>

              <mobile-component
                  :param="param"
                  :all-selected="all"
                  :selected="selected"
                  @callback-event = "v => smsDialogVisible = !v"
              />

            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="mailDialogVisible" max-width="600px" @click:outside="mailDialogVisible = false" @keydown.esc="mailDialogVisible = false">
          <v-card class="mx-auto">
            <v-system-bar>
              메일 발송
              <v-spacer></v-spacer>
              <v-icon @click="mailDialogVisible = false">mdi-close</v-icon>
            </v-system-bar>
            <v-card-text>

              <mail-component
                  :param="param"
                  :all-selected="all"
                  :selected="selected"
                  :is-part="true"
                  @callback-event = "v => mailDialogVisible = !v"
              />

            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="excelDialog" max-width="500px" @click:outside="excelDialog = false" @keydown.esc="excelDialog = false">
          <v-card>
            <v-card-title>
              <span class="headline">회원정보 일괄 등록</span>
            </v-card-title>

            <v-card-text>
              <div class="fieldWrap mgb2">
                <ul class="fieldBx">
                  <li class="formList">
                    <dl>
                      <dd class="mgr">
                        <v-btn href="/attachment/sec/member.xlsx" class="vBtn vIconResize mgr" color="#607d8b" dark>
                          <v-icon left dark>cloud_download</v-icon>
                          회원 업로드 양식 다운로드</v-btn>
                      </dd>
                    </dl>
                  </li>
                  <li class="formList">
                    <dl>
                      <dt class="formTit">엑셀 파일</dt>
                      <dd class="mgr">
                        <v-file-input
                            accept=".xlsx, .xls" placeholder="회원 형식의 엑셀 파일을 선택해주세요."
                            prepend-icon="mdi-file-excel"
                            v-model="excelFile"
                        />
                      </dd>
                    </dl>
                  </li>
                </ul>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey" dark @click="excelDialog = false">
                <v-icon left dark>mdi mdi-close</v-icon>
                창닫기</v-btn>
              <v-btn color="success" dark @click="excelUpload()">
                <v-icon left dark>cloud_upload</v-icon>
                업로드
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </article>

  </section>
</template>

<script>
import DateRageComponent from "@/views/component/DateRageComponent";
import mobileComponent from "@/views/component/MobileComponent";
import mailComponent from "@/views/component/MailComponent";

import secUserApi from '@/api/SecUserApi'

// import _ from "lodash";

export default {
  name: "SecUsers",
  components: {
    'date-range-component': DateRageComponent,
    // 'user-form': UserForm,
    mobileComponent,
    mailComponent
  },
  data: () => ({
    date: new Date(),
    // fromDate: new Date().toISOString().substr(0, 10),
    // toDate: new Date().toISOString().substr(0, 10),
    menu: false,
    menu2: false,
    keywordType: ['아이디', '이름', '닉네임', '휴대폰'],
    monthLists: [
      {value: 1, text: '1개월'}, {value: 3, text: '3개월'}, {value: 6, text: '6개월'},
      {value: 12, text: '1년'}, {value: 0, text: '전체'}],
    monthOn: false,
    activeItem: null,
    userTypes: [{value: null, text: '전체'}, {value: true, text: '삼성전자 관리 회원'}, {value: false, text: '전자사랑 회원'}],
    emailType: [{value: null, text: '전체'}, {value: true, text: 'Y'}, {value: false, text: 'N'}],
    smsType: [{value: null, text: '전체'}, {value: true, text: 'Y'}, {value: false, text: 'N'}],
    searchColumns: [
        {value: null, text: '전체'},
        {value: 'name', text: '이름'},
        {value: 'retirementDepartment', text: '부서'},
        {value: 'retirementPosition', text: '직위'},
        {value: 'mobileNo', text: '휴대폰번호'},
        {value: 'userId', text: '아이디'},
        {value: 'email', text: '이메일'}
    ],
    selected: [],
    headers: [
      // {text: '역할', value: 'userHasRoles', sortable: false, align: 'left'},
      {text: '회원구분', value: 'isSecManaged', align: 'left'},
      {text: '청탁금지법대상', value: 'isAntiGraftLawTarget', align: 'left'},
      {text: '이름', value: 'name', align: 'left'},
      {text: '직위', value: 'retirementPosition', align: 'left'},
      {text: '부서', value: 'retirementDepartment', align: 'left'},
      {text: '생년월일', value: 'birthDate'},
      {text: '휴대폰번호', value: 'mobileNo'},
      {text: '아이디', value: 'userId', align: 'left'},
      {text: '이메일', value: 'email', align: 'left'},
      // {text: '분과', value: 'departmentGroup', align: 'left'},
      // {text: '동호회', value: 'clubGroup', align: 'left'},
      // {text: '가입일', value: 'createdAt'},
      {
        text: '관리',
        value: 'actions',
        align: 'center',
        sortable: false
      }
    ],
    param: {
      searchSecMember: true,
      keyType: null,
      searchKeyword: null,
      username: null,
      name: null,
      local: null,
      fromJoin: null,
      toJoin: null,
      sms: null,
      page: 1
    },
    options: {},
    users: [],
    totalItems: 0,
    searchDate: [],
    dialogVisible: false,
    groupDialogVisible: false,
    smsDialogVisible: false,
    mailDialogVisible: false,
    selectedUser: {},
    waitingSearch: false,
    searchValue: null,
    currentStateName:'전체',
    all: false,
    excelDialog: false,
    excelFile: null
  }),
  computed: {
    searchColumnText() {
      if(this.param.searchColumn) {
        return (this.searchColumns.filter(c => c.value === this.param.searchColumn)?.[0]??{}).text;
      } else {
        return '이름/직위/부서/휴대폰번호/아이디/이메일 검색'
      }
    }
  },
  watch: {
    options: {
      handler () {
        this.search();
      },
      deep: true,
    },
    searchValue: {
      handler(nv) {
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.search();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      }
    },
  },
  methods: {
    excelUploadDialog() {
      this.excelDialog = true;
    },
    excelUpload() {
      if(!this.excelFile) {
        alert("파일을 선택해주세요");
        return;
      }
      if(confirm('일괄 등록 하시겠습니까?')) {
        secUserApi.uploadExcel(this.excelFile).then(() => {
          this.excelDialog = false;
          this.excelFile = null;
          this.search();
          alert("완료되었습니다.");
        });
      }
    },
    onRowClick(item) {
      this.$router.push({path: `/sec/users/form/${item.userId}`})
    },
    initSearch() {
      for (const [key] of Object.entries(this.param)) {
        this.param[key] = '';
      }
    },
    getSearchDate(searchDate = []) {
      this.searchDate = searchDate;
      this.search();
    },
    selectItem(months) {
      this.activeItem = months;
      this.searchDate = [];
      if (this.activeItem !== 0) {
        this.searchDate.push(this.$moment().subtract(months, "months").format('YYYY-MM-DD'));
        this.searchDate.push(this.$moment().format('YYYY-MM-DD'));
      }
      this.search();
    },
    search() {
      const params = this.generateParameters();

      secUserApi.pagedList(params).then(data => {
        this.users = data.content;
        this.totalItems = data.totalElements;
        this.$store.commit('setParams', params)
      });
      //
      // userApi.list(params).then(data => {
      //   this.users = data.content;
      //   this.totalItems = data.totalElements;
      //   this.$store.commit('setParams', params);
      // });

      this.waitingSearch = false;
    },
    generateParameters() {
      delete this.options.searchKeyword;
      delete this.options.searchSecMember;
      delete this.options.searchDate;

      const {  page, itemsPerPage, size } = this.options;

      const params = {...this.param, ...this.options, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};
      if(params.searchDate) {
        this.searchDate = params.searchDate;
      }
      // if (this.activeItem > 0) {
      if (this.searchDate) {
        // params.fromJoin = this.fromDate;
        // params.toJoin = this.toDate;
        params.fromDate = this.searchDate[0];
        params.toDate = this.searchDate[1];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }
      params.searchDate = this.searchDate;
      return params;
    },
    createForm(){
      this.$router.push({path: `/sec/users/form/`})
      // this.selectedUser = {};
      // this.dialogVisible = true;
      // this.$router.push({path: '/user/form'})
    },
    savedUser() {
      this.dialogVisible = false;
      this.search();
    },
    updateForm(item) {
      this.$router.push({path: `/sec/users/form/${item.userId}`})
    },
    deleteUser(item) {
      if(confirm('삭제하시겠습니까?')) {
        secUserApi.delete(item.userId).then(() => {
          this.search();
          alert("삭제되었습니다.")
        });
      }
    },
    async excelDownload() {

      const passwd = prompt('엑셀에 설정할 패스워드를 입력하세요.(선택사항)', '');

      const params = this.generateParameters();

      let prefix = this.param.searchSecMember === null ? "전체" : this.param.searchSecMember ? "삼성전자 관리 회원" : "전자사랑 회원";

      let dateName = (this.searchDate && this.searchDate.length > 0) ? params.fromDate + '_' + params.toDate : '';

      const suffix = ((dateName) ? "_" + dateName : '');

      params.excelPassword = passwd;

      await secUserApi.excel(params, prefix, suffix);
    }
  },
  created: function () {

    const storedParams = this.$store.getters?.params??{};
    if(storedParams.name !== this.$options.name)
      this.$store.commit('setParams', Object.assign(this.param, {name:this.$options.name}))
    else {
      this.options = storedParams
      this.param = storedParams
      this.searchValue = this.param.searchKeyword
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.h2Title {
  @include h2-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 3px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            width: 280px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }
              width: 55px;
              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}

.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        margin-right: 15px;
      }
    }
  }
}
</style>
